$('.accordion .item .title').click(function(){
    if($(this).next('.content').hasClass('active')) {
        return $(this).next('.content').removeClass('active');
    }
    
    $(this).next('.content').addClass('active');
});

for (let index = 0; index < 12; index++) {
    new Splide( '#image-carousel-'+index, {
      type: 'loop',
      autoplay : true,
    }).mount();
}


var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
if (urlParams.has('name')) {
  var name = urlParams.get('name');
  $('.lsg-material-list-box .item[data-id="' + name + '"]').addClass('active');
  $('.lsg-material-item#'+name).addClass('active');
}

$('.lsg-material-list-box .item').click(function(){
    $('.lsg-material-list-box .item').removeClass('active');
    $(this).addClass('active');
    
    let id = $(this).data('id');
    $('.lsg-material-item').removeClass('active');
    $('.lsg-material-item#'+id).addClass('active');

});